// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Select from "@insite/mobius/Select";
import updateSearchFields from "@tps/Overrides/Pages/Handlers/UpdateSearchFields";
import { ORDER_TYPES } from "@tps/XDL/constants";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

export interface ExtendedGetOrdersApiParameter extends GetOrdersApiParameter {
    orderType?: string | undefined;
    orderedBy?: string;
}

const mapStateToProps = (state: ApplicationState) => ({
    parameter: state.pages.orderHistory.getOrdersParameter as ExtendedGetOrdersApiParameter,
});

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const OrderHistorySearchFieldOrderType: React.FC<Props> = ({ parameter, updateSearchFields }) => {
    const handleChange = (event: React.FormEvent<HTMLSelectElement>) => {
        const value = event.currentTarget.value;

        updateSearchFields({
            orderType: value === "ALL" ? undefined : value,
        });
    };

    const value = parameter.orderType || "";

    return (
        <SearchFieldWrapper>
            <Select
                label={translate("Order Type")}
                value={value}
                onChange={handleChange}
                data-test-selector="orderHistory_filterOrderType"
            >
                <option value="">{translate("All")}</option>
                {ORDER_TYPES.map(type => (
                    <option key={type.value} value={type.value}>
                        {type.label}
                    </option>
                ))}
            </Select>
        </SearchFieldWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistorySearchFieldOrderType),
    definition: {
        group: "Order History",
        displayName: "Order Type",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
